(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-fulfillment-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const dialog = document.getElementById('RrnCartGuardDialog');
      if (!dialog) return;

      const startNewCartButton = dialog.querySelector('[data-rrn-start-new-cart]');
      const errorMessage = dialog.querySelector('[data-rrn-cart-guard-error]');
      const messages = Array.from(dialog.querySelectorAll('[data-rrn-conflict-message]'));
      let currentMode = dialog.dataset.currentMode || '';
      let pendingAction = null;
      let intendedMode = '';

      const conflictsWithCart = (mode) => {
        if (!mode || !currentMode) return false;
        return currentMode === 'mixed' || currentMode !== mode;
      };

      const openConflictDialog = (mode, action) => {
        intendedMode = mode;
        pendingAction = action;
        errorMessage.hidden = true;

        messages.forEach((message) => {
          const messageMode = currentMode === 'mixed' ? 'mixed' : mode;
          message.hidden = message.dataset.rrnConflictMessage !== messageMode;
        });

        startNewCartButton.textContent = mode === 'direct_delivery'
          ? startNewCartButton.dataset.directLabel
          : startNewCartButton.dataset.localLabel;

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      };

      document.addEventListener('submit', (event) => {
        const productForm = event.target.closest('product-form');
        if (!productForm) return;

        const mode = productForm.dataset.fulfillmentMode || dialog.dataset.pageProductMode;
        if (!mode) return;

        if (conflictsWithCart(mode)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openConflictDialog(mode, {
            type: 'submit',
            target: event.target,
            submitter: event.submitter
          });
          return;
        }

        if (!currentMode) currentMode = mode;
      }, true);

      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const addToCart = event.target.closest('add-to-cart[data-fulfillment-mode]');
        if (!addToCart) return;

        const mode = addToCart.dataset.fulfillmentMode;
        if (conflictsWithCart(mode)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openConflictDialog(mode, {
            type: 'click',
            target: addToCart
          });
          return;
        }

        if (!currentMode) currentMode = mode;
      }, true);

      startNewCartButton.addEventListener('click', async () => {
        const originalLabel = startNewCartButton.textContent;
        startNewCartButton.disabled = true;
        startNewCartButton.textContent = startNewCartButton.dataset.loadingLabel;
        errorMessage.hidden = true;

        try {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootUrl}cart/clear.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
          });

          if (!response.ok) throw new Error('Unable to clear cart');

          currentMode = '';
          dialog.dataset.currentMode = '';
          dialog.close();

          const action = pendingAction;
          pendingAction = null;

          if (action?.type === 'submit') {
            action.target.requestSubmit(action.submitter || undefined);
          } else if (action?.type === 'click') {
            action.target.click();
          }
        } catch (error) {
          errorMessage.hidden = false;
        } finally {
          startNewCartButton.disabled = false;
          startNewCartButton.textContent = originalLabel;
        }
      });

      dialog.addEventListener('close', () => {
        pendingAction = null;
        intendedMode = '';
        errorMessage.hidden = true;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
